import { frontendURL } from 'dashboard/helper/URLHelper';

const SocialLayout = () => import('social/views/SocialLayout.vue');
const SocialPosts = () => import('social/views/SocialPosts.vue');
const SocialAccounts = () => import('social/views/SocialAccounts.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/social'),
    component: SocialLayout,
    children: [
      {
        path: '',
        redirect: to =>
          frontendURL(`accounts/${to.params.accountId}/social/posts`),
      },
      {
        path: 'posts',
        name: 'social_posts',
        component: SocialPosts,
        meta: { permissions: ['administrator', 'agent', 'custom_role'] },
      },
      {
        path: 'accounts',
        name: 'social_accounts',
        component: SocialAccounts,
        meta: { permissions: ['administrator', 'agent', 'custom_role'] },
      },
    ],
  },
];

export const sidebarItem = t => ({
  name: 'Social',
  label: t('SOCIAL.SIDEBAR_LABEL'),
  icon: 'i-lucide-share-2',
  children: [
    {
      name: 'Social Posts',
      label: t('SOCIAL.POSTS_LABEL'),
      icon: 'i-lucide-calendar',
      to: { name: 'social_posts' },
      activeOn: ['social_posts'],
    },
    {
      name: 'Social Accounts',
      label: t('SOCIAL.ACCOUNTS_LABEL'),
      icon: 'i-lucide-link',
      to: { name: 'social_accounts' },
      activeOn: ['social_accounts'],
    },
  ],
});
